import { Body, colors, Margin, Spacer } from '@spritz-finance/ui'
import dayjs from 'dayjs'
import styled from 'styled-components'
import { Column } from '../../../../components/Layout/Column'
import { Row } from '../../../../components/Layout/Row'
import { Bill } from '../bills/Bills'
import { InstitutionImage } from '../InstitutionImage'

type BillSelectRowProps = {
    bill: Bill
    onItemClick?: (bill: Bill) => void
}

export const BillContainer = styled.div`
    display: flex;
    flex: 1;
    border: 1px solid ${colors.charcoal};
    transition: all 0.3s ease-in-out;
    box-sizing: border-box;
    border-radius: 20px;
    padding: ${Margin.Med} ${Margin.Large};

    &:hover {
        border-color: ${colors.silverGray};
        cursor: pointer;
        box-shadow: 20px 20px 30px rgba(0, 0, 0, 0.1);
    }
`

export const BillSelectRow: React.VFC<BillSelectRowProps> = ({ bill, onItemClick }) => {
    return (
        <BillContainer onClick={() => onItemClick?.(bill)}>
            <Row flex={1}>
                <InstitutionImage institution={bill.institution} size={40} />
                <Spacer width={8} />
                <Column flex={1}>
                    <Row>
                        <Body.Med secondary size={14}>
                            {bill.institution?.name}
                        </Body.Med>
                    </Row>
                    <div style={{ width: '100%' }}>
                        <Row align="space-between" flex={1}>
                            <Body.Bold size={16}>{bill.name}</Body.Bold>
                            <Spacer width={8} />
                            <Body.Med size={10} color={colors.medGrey}>
                                {bill.openedAt
                                    ? `Opened: ${dayjs(bill.openedAt).format('MM/DD/YYYY')}`
                                    : ''}
                            </Body.Med>
                        </Row>
                    </div>
                </Column>
            </Row>
        </BillContainer>
    )
}
